import React from 'react';

export default function SearchRow({ children }) {
  return <div className="search-row">{children}</div>;
}

export function SearchInput({ value, onChange, placeholder }) {
  return (
    <div className="search-input-wrap">
      <span className="search-icon" aria-hidden>🔍</span>
      <input
        className="search-input"
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
      />
    </div>
  );
}
